export default __webpack_public_path__ + "static/media/the_venue_5.3a3718f9.png";